import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const TagContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${pxToRem(5)};
  padding: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(10)};
  border-radius: ${pxToRem(3)};
  background: #d6d6d6;
  margin: calc(${pxToRem(5)} / 2);
  &.truncated > div {
    max-width: ${pxToRem(100)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
